export const validation = {
  cardNumber: "Card number is required",
  cardName: "name is required",
  expiryDate: "Expiration date is required",
  cvv: "CVV number is required",
};
